import { pickList } from '../sales/sales-report-search'
import { validatePeriodSearch } from '../report-period'
import type { ReportPeriodSearch } from '../report-period'
import type { CashbookReportParams } from '@/lib/api/report-api'

/** Kỳ mặc định: Hôm nay → mở thẳng phiếu của hôm nay (như Báo cáo bán hàng). */
export const CASHBOOK_DEFAULT_PRESET = 'today' as const

export const CASHBOOK_KINDS = ['income', 'expense'] as const
export type CashbookKind = (typeof CASHBOOK_KINDS)[number]
/** Phương thức có trong phiếu thu, khoản chi và phiếu hoàn. */
export const CASHBOOK_METHODS = [
    'cash',
    'bank_transfer',
    'cod_via_carrier',
] as const
export type CashbookMethod = (typeof CASHBOOK_METHODS)[number]

/** Số người tạo tối đa trong một lần lọc (server cũng chặn 100). */
export const MAX_CASHBOOK_CREATORS = 100

const UUID_RE =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** Bộ lọc Báo cáo thu chi: kỳ chung + loại phiếu + phương thức + người tạo
 * (id, M-143) — rỗng = tất cả. */
export interface CashbookReportSearch extends ReportPeriodSearch {
    kind?: CashbookKind[]
    method?: CashbookMethod[]
    created_by?: string[]
}

/** Id người tạo trên URL: chuỗi "a,b" hoặc mảng → id hợp lệ, bỏ trùng. */
export function pickCreatorIds(raw: unknown): string[] | undefined {
    const parts = Array.isArray(raw)
        ? raw.map(String)
        : typeof raw === 'string'
          ? raw.split(',')
          : []
    const ids = [
        ...new Set(
            parts
                .map((p) => p.trim().toLowerCase())
                .filter((p) => UUID_RE.test(p)),
        ),
    ].slice(0, MAX_CASHBOOK_CREATORS)
    return ids.length > 0 ? ids : undefined
}

export function validateCashbookReportSearch(
    raw: Record<string, unknown>,
): CashbookReportSearch {
    return {
        ...validatePeriodSearch({
            ...raw,
            preset: raw.preset ?? CASHBOOK_DEFAULT_PRESET,
        }),
        kind: pickList(raw.kind, CASHBOOK_KINDS),
        method: pickList(raw.method, CASHBOOK_METHODS),
        created_by: pickCreatorIds(raw.created_by),
    }
}

/** Tham số API cho một khoảng ngày theo bộ lọc hiện tại. */
export function cashbookApiParams(
    search: CashbookReportSearch,
    from: string,
    to: string,
): CashbookReportParams {
    return {
        date_from: from,
        date_to: to,
        kind: search.kind?.join(','),
        method: search.method?.join(','),
        created_by: search.created_by?.join(','),
    }
}
